import { ReactNode, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import ErrorBoundaryFallback from "../../components/display/ErrorBoundaryFallback";
import AuthProviderWrapper from "../../context/auth/AuthProviderWrapper";
import FpApiProviderWrapper from "../../context/fpapi/FpApiProviderWrapper";
import { initializeDebugger } from "../debugger";
import { dynamicActivate } from "../../utils/i18n";
import UserInfoProvider from "../../context/userinfo/UserInfoContext";
import { initializeErrorMonitoring, reportErrorToSentry, setSentryTag } from "../sentry/sentry";
import { ThemeProvider } from "../../providers/ThemeProvider";
import { Loader } from "pixel";

type FpAppsInitProps = {
  children?: ReactNode;
};

// Activate the locale for I18nProvider
dynamicActivate();
initializeErrorMonitoring();
setSentryTag({ tagName: "app", tagValue: import.meta.env.VITE_APP_TYPE });

initializeDebugger();

const errorHandler = (error: any) => {
  reportErrorToSentry(error);
};

const FpDashboardInit = ({ children }: FpAppsInitProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={errorHandler}>
      <Suspense fallback={<Loader variant="fullpage" />}>
        <ThemeProvider>
          <AuthProviderWrapper>
            <UserInfoProvider>
              <FpApiProviderWrapper>{children}</FpApiProviderWrapper>
            </UserInfoProvider>
          </AuthProviderWrapper>
        </ThemeProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default FpDashboardInit;
